
import { mapState } from 'vuex';

export default {
  name: 'NavDropdownMenu',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState(['showNavbar']),
    dropdownItems() {
      return this.items.slice(1);
    },
  },
};
